import { Switch } from "@/components/ui/switch";
import { useState } from "react";
import MenuButton from "../../_components/MenuButton";
import {
	disableFaceAuth,
	enableFaceAuth,
	isFaceAuthEnabled,
} from "../faceid/faceAuth";

export default function FaceIdButton() {
	const [checked, setChecked] = useState(isFaceAuthEnabled());

	const handleToggle = (value: boolean) => {
		setChecked(value);
		if (value) {
			enableFaceAuth();
		} else {
			disableFaceAuth();
		}
	};

	return (
		<div>
			<MenuButton
				fontWeight="medium"
				label={
					<>
						Face ID{" "}
						{checked ? (
							<span className="text-textLight font-semibold text-xs">
								Enabled
							</span>
						) : (
							<span className="text-utility-red font-semibold text-xs">
								Disabled
							</span>
						)}
					</>
				}
				rightElement={
					<Switch checked={checked} onCheckedChange={handleToggle}></Switch>
				}
			/>
		</div>
	);
}
